<template>
  <div>
    <v-snackbar
      :color="snackbar.color"
      v-model="snackbar.visible"
      :timeout="8000"
    >
      {{ snackbar.msg }}
      <template v-slot:action="{ attrs }">
        <v-btn text color="white" v-bind="attrs" @click="resetSnackbar()">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-container fluid class="py-0">
      <v-row class="topbanner-bg">
        <v-col cols="12">
          <v-row class="justify-center">
            <v-col cols="6" md="4" class="text-center">
                <v-img
                  aspect-ratio="2"
                  max-width="200"
                  src="./assets/logo_app_glow.png"
                  style="margin: 0 auto"
                />
            </v-col>
          </v-row>
          <v-row class="justify-center">            
            <v-col cols="12" md="6" class="mt-4 mb-5 text-center">
              <v-card>
                <v-card-title class="font-weight-bold">                    
                  <v-row>
                    <v-col cols="12" class="pt-0">
                      <div v-if="!activeSubscription">Acquista un abbonamento a SelfDiet!</div>
                      <template v-if="token">
                        <v-row>      
                          <v-col cols="12" md="10" class="subtitle-1 text-left font-weight-bold pt-0">   
                            Benvenuto {{ user.name }} {{ user.surname }}
                          </v-col>   
                          <v-col cols="12" md="2" class="text-right pt-0">   
                            <v-btn small rounded dark color="red" @click="clearData">Esci</v-btn>
                          </v-col>
                        </v-row>
                        <div v-if="activeSubscription" class="headline font-weight-bold success--text pt-2">
                          Hai già un abbonamento valido fino al
                          {{ moment(activeSubscription.endDate).format("DD/MM/YYYY") }}
                        </div>
                      </template>
                      <template v-else>
                        <div class="mt-4 title">
                          Accedi o registrati per procedere all'acquisto.
                        </div>
                      </template>
                    </v-col>
                  </v-row>
                </v-card-title>
                <template v-if="!token">
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" class="text-left" v-if="registering">
                        <v-btn small text @click="registering = false">
                          <v-icon left small>mdi-arrow-left</v-icon> annulla
                        </v-btn>
                      </v-col>
                    </v-row>
                    <form
                      @submit.prevent="login"
                      data-vv-scope="login"
                      v-if="!registering"
                    >
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            id="email"
                            v-model="user.email"
                            v-validate.disable="'required|email'"
                            rounded
                            filled
                            name="email"
                            type="email"
                            label="Email"
                            data-vv-as="Email"
                            :error="errors.has('email')"
                            :error-messages="errors.collect('email')"
                            autocomplete="off"
                          />
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            id="password"
                            v-model="user.password"
                            v-validate.disable="'required|min:5'"
                            rounded
                            filled
                            name="password"
                            type="password"
                            label="Password"
                            data-vv-as="Password"
                            :error="errors.has('password')"
                            :error-messages="errors.collect('password')"
                            autocomplete="off"
                          />
                        </v-col>
                        <v-col cols="12" class="text-center mt-2">
                          <v-btn type="submit" color="primary" rounded
                            >Accedi</v-btn
                          >
                        </v-col>
                      </v-row>
                    </form>
                    <form
                      @submit.prevent="register"
                      data-vv-scope="register"
                      v-else
                    >
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-text-field
                            id="nome"
                            v-model="user.name"
                            v-validate.disable="'required'"
                            rounded
                            filled
                            name="nome"
                            label="Nome"
                            data-vv-as="Nome"
                            :error="errors.has('nome')"
                            :error-messages="errors.collect('nome')"
                            autocomplete="off"
                          />
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            id="cognome"
                            v-model="user.surname"
                            v-validate.disable="'required'"
                            rounded
                            filled
                            name="cognome"
                            label="Cognome"
                            data-vv-as="Cognome"
                            :error="errors.has('cognome')"
                            :error-messages="errors.collect('cognome')"
                            autocomplete="off"
                          />
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            id="email"
                            v-model="user.email"
                            v-validate.disable="'required|email'"
                            rounded
                            filled
                            name="email"
                            type="email"
                            label="Email"
                            data-vv-as="Email"
                            :error="errors.has('email')"
                            :error-messages="errors.collect('email')"
                            autocomplete="off"
                          />
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            id="telefono"
                            v-model="user.phone"
                            v-validate.disable="'required'"
                            rounded
                            filled
                            type="tel"
                            name="telefono"
                            label="Telefono"
                            data-vv-as="Telefono"
                            :error="errors.has('telefono')"
                            :error-messages="errors.collect('telefono')"
                            autocomplete="off"
                          />
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-autocomplete
                            id="provincia"
                            v-model="user.province"
                            v-validate.disable="'required'"
                            name="provincia"
                            filled
                            rounded
                            label="Provincia"
                            data-vv-as="Provincia"
                            :error="errors.has('provincia')"
                            :error-messages="errors.collect('provincia')"
                            :items="allProvinces"
                            item-value="nome"
                            item-text="nome"
                            clearable
                            autocomplete="off"
                            @change="filterCities"
                          />
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-autocomplete
                            id="città"
                            v-model="user.city"
                            v-validate.disable="'required'"
                            name="città"
                            filled
                            rounded
                            label="Città"
                            :items="allCities"
                            item-value="nome"
                            item-text="nome"
                            clearable
                            data-vv-as="Città"
                            :error="errors.has('città')"
                            :error-messages="errors.collect('città')"
                            autocomplete="off"
                          />
                        </v-col>
                        <v-col cols="12" class="text-center mt-2">
                          <v-btn type="submit" color="primary" rounded
                            >Registrati</v-btn
                          >
                        </v-col>
                      </v-row>
                    </form>
                    <v-row v-if="!registering">
                      <v-col cols="12" class="text-center py-0">
                        <small>- oppure -</small>
                      </v-col>
                      <v-col cols="12" class="text-center">
                        <v-btn small text rounded @click="registering = true"
                          >Registrati</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-card-text>
                </template>
                <template v-else-if="token">
                  <v-card-text>
                    <template v-if="addingSubscription">
                      <v-row class="justify-center">
                        <v-col cols="12" md="8" class="text-center pb-5">
                          <div class="mb-2">
                            <v-select
                              dense
                              rounded
                              outlined
                              filled
                              v-model="rate"
                              return-object
                              :items="rates.filter((r) => !r.unaTantum && r.enabled)"
                              placeholder="Seleziona un abbonamento"
                              @change="initPayment"
                            >
                              <template v-slot:item="{ item }">
                                <span class="font-weight-bold text-uppercase mr-2">{{item.description}}</span> 
                                ({{item.duration}} giorni) 
                                <v-chip label class="ml-5 font-weight-bold">€ {{parseFloat(item.price).toFixed(2)}}</v-chip>
                              </template>
                              <template v-slot:selection="{ item }">
                                <span class="font-weight-bold text-uppercase mr-2">{{item.description}}</span> 
                                ({{item.duration}} giorni) 
                              </template>
                            </v-select>
                          </div>
                          <template v-if="rate.price">
                            <div v-if="!subscriptions || !subscriptions.length" class="mb-5">
                              <div style="line-height: 12px">
                                <strong
                                  >€ {{ parseFloat(costoValutazioneIniziale.price).toFixed(2) }}</strong
                                >
                                <div></div>
                                <small>
                                  {{costoValutazioneIniziale.description}}
                                </small>
                              </div>
                              +
                              <div style="line-height: 12px">
                                <strong
                                  >€
                                  {{ parseFloat(rate.price).toFixed(2) }}</strong
                                >
                                <div></div>
                                <small>
                                  abbonamento per {{ rate.duration }} giorni
                                </small>
                              </div>
                            </div>
                            <v-divider />
                            <div class="font-weight-bold mt-5">
                              IMPORTO TOTALE
                            </div>
                            <v-chip color="green" dark>
                              <h2>€ {{ totalAmount }}</h2>
                            </v-chip>
                          </template>
                        </v-col>
                        <v-col cols="12" class="text-center mt-3" v-if="rate.price">
                          <stripe-checkout
                            ref="checkoutRef"
                            locale="it"
                            :pk="env.VUE_APP_STRIPE_API_KEY"
                            :session-id="paymentSessionID"
                          />
                          <v-btn color="primary" dark rounded @click="pay"
                            >Procedi all'acquisto</v-btn
                          >
                        </v-col>
                      </v-row>                      
                    </template>
                    <template v-else>
                      <v-btn rounded dark color="primary" class="mb-3" @click="addingSubscription=true">
                        Aggiungi abbonamento
                      </v-btn>
                    </template>
                  </v-card-text>
                </template>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import listaComuni from "./assets/comuni.json";
import { StripeCheckout } from "@vue-stripe/vue-stripe";
import moment from "moment";
import _ from "lodash";
import { mapActions, mapGetters, mapMutations } from "vuex";
import JSEncrypt from "jsencrypt";

export default {
  components: {
    StripeCheckout,
  },

  data: () => ({
    listaComuni,
    moment,
    env: process.env,
    paymentSessionID: null,
    allCities: [],
    registering: false,
    addingSubscription: false,
    rate: {}
  }),

  computed: {
    ...mapGetters([
      "getUser",
      "getToken",
      "getSnackbar",
      "getRates",
      "getSubscriptions",
    ]),
    user() {
      return this.getUser;
    },
    token() {
      return this.getToken;
    },
    snackbar() {
      return this.getSnackbar;
    },
    subscriptions() {
      return this.getSubscriptions;
    },
    activeSubscription() {      
      return this.subscriptions && this.subscriptions.length ? this.subscriptions.find((s) => this.moment(s.endDate).isAfter(this.moment())) : null;
    },
    rates() {
      return this.getRates;
    },
    costoValutazioneIniziale() {
      return this.rates.find((r) => r.unaTantum);
    },
    allProvinces() {
      return _.orderBy(
        listaComuni.map((c) => {
          return c.provincia;
        }),
        "nome"
      );
    },
    totalAmount() {
      return !this.subscriptions.length
        ? parseFloat(parseFloat(this.rate.price) + parseFloat(this.costoValutazioneIniziale.price)).toFixed(2)
        : parseFloat(this.rate.price).toFixed(2);
    },
  },

  methods: {
    ...mapActions(["userLogin", "userRegister", "loadSubscriptions", "loadRates"]),
    ...mapMutations(["setRates", "setSubscription", "resetSnackbar", "logout"]),
    initPayment() {
      this.$loading(true);
      let items = [];
      const rateValutazioneIniziale = this.rates.find((r) => r.unaTantum);
      if (!this.subscriptions.length && rateValutazioneIniziale) {
        items.push({
          price_data: {
            currency: 'EUR',
            product_data: {
              name: rateValutazioneIniziale.description,
            },
            unit_amount: this.stripeAmount(rateValutazioneIniziale.price),
          },
          quantity: 1,
        });
      }

      if(this.rate.price) {
        items.push({
          price_data: {
            currency: 'EUR',
            product_data: {
              name: this.rate.description + ' (' + this.rate.duration + ' giorni)',
            },
            unit_amount: this.stripeAmount(this.rate.price),
          },
          quantity: 1,
        });
      }

      this.axios
        .post("/subscriptions/getStripeToken", {
          metadata: {
            duration: this.rate.duration,
          },
          customer_email: this.user.email,
          line_items: items,
          recurrentSubscription: false
        })
        .then((response) => {
          this.$loading(false);
          this.paymentSessionID = response.data.id;
          this.subscriptionDialog = true;
        });
    },
    stripeAmount(price) {
      if(price.indexOf('.') > -1) {
        return price.replace('.','');
      } else {
        return price+'00';
      }
    },
    pay() {
      this.$refs.checkoutRef.redirectToCheckout();
    },
    async login() {
      try {
        const valid = await this.$validator.validateAll("login");
        if (valid) {
          const jsEncrypt = new JSEncrypt();
          jsEncrypt.setPublicKey(this.env.VUE_APP_PUBLIC_KEY);
          const encryptedPsw = jsEncrypt.encrypt(this.user.password).toString();
          this.userLogin({
            email: this.user.email,
            password: encryptedPsw,
          })
        }
      } catch (error) {
        return;
      }
    },
    async register() {
      try {
        const valid = await this.$validator.validateAll("register");
        if (valid) {
          this.$loading(true);
          this.userRegister(this.auth).then((res) => {
            if (res) {
              this.registering = false;
            }
          });
        }
      } catch (error) {
        return;
      }
    },
    filterCities() {
      this.allCities = _.orderBy(
        listaComuni.filter((c) => c.provincia.nome === this.user.province),
        "nome"
      );
    },
    checkToken() {
      if (this.token) {
        this.$loading(true);
        this.loadSubscriptions(this.user._id).then(() => {        
          this.loadRates().then(() => {
            this.$loading(false);
          }).catch(() => {
            this.clearData();
            this.$loading(false);
          });
        }).catch(() => {
          this.clearData();
          this.$loading(false);
        });
      }
    },
    clearData() {
      this.logout();
      this.paymentSessionID = null;
      this.allCities = [];
      this.registering = false;
      this.addingSubscription = false;
      this.rate = {};
    }
  },

  watch: {
    token() {
      this.checkToken();
    },
  },

  mounted() {
    this.checkToken();
  }
};
</script>

<style scoped>
.topbanner-bg {
  background-image: url("./assets/bg.png");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  min-height: 100vh;  
}
a.undecorated {
  text-decoration: none !important;
}
.prices {
  max-width: 370px;
  margin: 0 auto;
}
</style>
